import styled from 'styled-components'

// Styles for Klarna Container can be found at src/javascript/GlobalStyle.js

const Wrapper = styled.div`
  margin-top: 8px;
  min-height: 29px;
`

export { Wrapper }
